import React, { useState, useEffect, useRef } from 'react';

const AnnouncementBox = () => {
    const listRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false); // Track hover state

    useEffect(() => {
        const interval = setInterval(() => {
            if (listRef.current && !isHovered) { // Only scroll if not hovered
                const scrollHeight = listRef.current.scrollHeight;
                const clientHeight = listRef.current.clientHeight;

                // Check if the bottom of the list is reached
                if (listRef.current.scrollTop + clientHeight >= scrollHeight) {
                    listRef.current.scrollTop = 0; // Reset scroll to the top when it reaches the bottom
                } else {
                    listRef.current.scrollTop += 1; // Scroll down gradually
                }
            }
        }, 30); // Speed of the scrolling (lower is faster)

        // Cleanup interval on component unmount or when hover state changes
        return () => {
            clearInterval(interval);
        };
    }, [isHovered]);


    return (
        <>
            <div className="announcement-box rounded shadow-sm p-3 pt-0 mb-5 bg-white"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)} >
                <div className="announcement-title  text-white text-center p-2 font-weight-bold" style={{ backgroundColor: "#1d3243 " }}>
                    Announcements
                </div>
                <div
                    className="announcement-list"
                    style={{ maxHeight: '200px', overflow: 'hidden', position: 'relative' }}
                    ref={listRef}
                >
                    <ul style={{ listStyleType: "disc" }} className=" p-2 m-0">



                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/events/MRECWFILMCLUB_9thoct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                A Workshop on "Content Creation, Story Telling &amp; Digital Media" by MRECW FILM CLUB on 09 October, 2026.
                            </a>
                        </li>


                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ISTE Student Chapter presents "The Last Clue &amp; TECHNIX" in 3rd October, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Industrial Visit to NRSC on 5th &amp; 6th October, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Webinar on "Demystifying API &amp; SAP : From Campus to Career" on 3rd October, 2026.
                            </a>
                        </li>




                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/events/storyspeak_03oct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                MRECW Film Club presents "Story Speak" Story Content Challenge on 3rd October, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/images/media/NationalLevelWomenHackathon_9thoctto10thoct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                "NEXORA 2026" A National Level Women Hackathon 9th & 10th October, 2026.
                            </a>
                        </li>


                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/events/ESCAPEPROTOCOL&MOCKINTERVIEW_3rdoct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                CSI Student Chapter Presents "ESCAPE PROTOCOL & MOCK INTERVIEW" 3rd October, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/events/TECHZEN&SKETCHYOURSOLUTION_3rdoct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                IETE Student Chapter Presents "TECH ZEN & SKETCH YOUR SOLUTION" 3rd October, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/events/LOGICFORGE_3rdoct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                IEEE Student Chapter Presents "LOGIC FORGE" 3rd October, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/events/PEACEINACTIONSERVICEWITHPURPOSE_3rdoct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                MRECW NSS Unit I &amp; II Presents "PEACE IN ACTION - SERVICE WITH PURPOSE" 3rd October, 2026.
                            </a>
                        </li>



                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
    <a
        className="text-dark"
        href="../assets/events/GuestLecture_ResearchPublicationStrategies_30thSeptember2026.jpeg"
        target="_blank"
        rel="noopener noreferrer"
    >
        Guest Lecture on "Research Publication Strategies for Young Researchers" 30th September, 2026.
    </a>
</li>



                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/images/media/DroneX_29thto30sep2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Two Day Hands on Workshop on "DroneX" The Future of Aerial Technology 29th & 30th September, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/images/media/Cybershield_29septto1stoct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                A Three Day Workshop on "Cyber Shield"  From Threats to Defense 29th September to 1st October, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/images/media/AIPoweredEDA&FutureEngineering_1stoct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                A Three Day Workshop on "AI Powered EDA & Feature Engineering" 29th September to 1st October, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a
                                className="text-dark"
                                href="../assets/images/media/BulidIntelligentSystems_29septo1stoct2026.jpeg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                A Three-Day Workshop on "Build Intelligent Applications with Generative AI, RAG & Multimodal AI" 29th & 30th September and 1st October, 2026.
                            </a>
                        </li>

                        
                        


                       
                                         



                    </ul>
                </div>
                <div className="announcement-footer  text-center" style={{ backgroundColor: "#1d3243 " }}>
                    <a href="/Home/Events" className="d-block p-2 font-weight-bold text-white text-decoration-none">
                        View All
                    </a>
                </div >
            </div >
        </>
    );
};

export default AnnouncementBox;
